import { ClassRegistrationDetail } from '../models/class-registration-detail';
import { dateMapper } from './date.mapper';
import { includedProductMapper } from './included-prouct.mapper';
import { licenseStatusMapper } from './license-status.mapper';
import { orderItemMapper } from './order-item.mapper';
import { orderSpecialRequest } from './order-special-request.mapper';
import { paymentItemMapper } from './payment-item.mapper';
import { userMapper } from './user.mapper';

/**
 * Map to class detail registration.
 * @param {object} dto Dto.
 * @returns {ClassRegistrationDetail}
 */
function fromDto(dto) {
  return new ClassRegistrationDetail({
    id: dto.id,
    confirmationId: dto.confirmation_id,
    balance: dto.balance,
    certificateSendDate: dateMapper.fromDto(dto.cert_send_date),
    status: licenseStatusMapper.fromDto(dto.status),
    statusId: dto.status_id,
    userId: dto.user_id,
    user: dto.user ? userMapper.fromDto(dto.user) : null,
    groupCodeId: dto.group_code_id,
    classTypeId: dto.class_type_id,
    examTypeId: dto.exam_type_id,
    examLanguageId: dto.exam_language_id,
    geographyId: dto.geography_id,
    classId: dto.class_id,
    isNewSystem: dto.is_new_system,
    canDownloadCertificate: dto.can_download_certificate,
    registerUserId: dto.register_user_id,
    registrationGroupId: dto.registration_group_id,
    sourceId: dto.source_id,
    examScore: dto.exam_score,
    createdDate: dateMapper.fromDto(dto.create_date),
    editDate: dateMapper.fromDto(dto.edit_date),
    active: dto.active,
    flag: dto.flag,
    visible: dto.visible,
    orderItem: dto.order_item ? orderItemMapper.fromDto(dto.order_item) : null,
    orderSpecialRequests: dto.order_special_requests ? dto.order_special_requests.map(order => orderSpecialRequest.fromDto(order)) : [],
    class: dto.class ? {
      id: dto.class.id,
      name: dto.class.name,
      categoryId: dto.class.category_id,
      statusId: dto.class.status_id,
      classDate: dto.class?.class_date ? dateMapper.fromDto(dto.class.class_date) : null,
      startTime: dto.class.start_time,
      endTime: dto.class.end_time,
      arriveTime: dto.class.arrive_time,
      examStartTime: dto.class.exam_start_time,
      examEndTime: dto.class.exam_end_time,
      examArriveTime: dto.class.exam_arrive_time,
      classLocation: dto.class.class_location ? {
        id: dto.class.class_location.id,
        name: dto.class.class_location.name,
        displayName: dto.class.class_location.display_name,
        capacity: dto.class.class_location.capacity,
        address: {
          id: dto.class.class_location.address.id,
          street: dto.class.class_location.address.street,
          street2: dto.class.class_location.address.street2,
          city: dto.class.class_location.address.city,
          stateCode: dto.class.class_location.address.state_code,
          zip: dto.class.class_location.address.zip,
          region: dto.class.class_location.address.region,
        },
      } : null,
      instructor: dto.class.instructor ? userMapper.fromDto(dto.class.instructor) : null,
    } : null,
    package: dto.package ? {
      id: dto.package.id,
      name: dto.package.name,
      description: dto.package.description,
      classCategoryId: dto.package.class_category_id,
      includedProducts: dto.package.included_products
        ? dto.package.included_products.map(product => includedProductMapper.fromDto(product))
        : [],
    } : null,
    studentAccessPage: dto.student_access_page,
    language: dto.language,
    examLanguage: dto.exam_language,
    specialRequest: dto.special_request,
    payment: dto.payment != null ? paymentItemMapper.fromDto(dto.payment) : null,
    refundPayment: dto.refund_payment ? paymentItemMapper.refundPaymentFromDto(dto.refund_payment) : null,
    expirationDate: dto.expiration_info ? dateMapper.fromDto(dto.expiration_info.date) : null,
    canAssignClass: dto.expiration_info ? dto.expiration_info.can_assign_class : true,
  });
}

export const classRegistrationDetailMapper = {
  fromDto,
};
